import { formartOnlyNumber } from '@unicus/react-ui-kit';
const mobilePhoneValidator = (_, value = '') => {
  const formattedValue = formartOnlyNumber(value);

  if (!formattedValue) {
    return Promise.resolve();
  }

  if (formattedValue.length < 11) {
    return Promise.reject(new Error('Celular inválido'));
  }

  return Promise.resolve();
};

export default mobilePhoneValidator;
